export default __webpack_public_path__ + "static/mobile-solid-04973fecb5310ad0e6db8d91518b046e.png";